import { ProductDownloadTabEnum } from 'modules/stores/store/content/product/digital-product/product-download/enum/product-download-tab-enum'

export const getNextTab = (tab: ProductDownloadTabEnum) => {
  const tabs = [
    ProductDownloadTabEnum.thumbnail,
    ProductDownloadTabEnum.digital_download,
    ProductDownloadTabEnum.checkout,
    ProductDownloadTabEnum.thank_you,
  ]

  const currentTabIndex = tabs.indexOf(tab)

  return tabs[currentTabIndex + 1]
}
